import React from 'react';
import { Input, Select, InputNumber, Checkbox, Radio } from 'antd';
import LookupField from '../../../components/LookupField';

const CATEGORY_OPTIONS = [
  { value: 'C', label: 'C 客戶' },
  { value: 'D', label: 'D 廠商' },
  { value: 'CD', label: 'CD 客供' },
  { value: 'F', label: 'F 銀行' },
  { value: 'M', label: 'M 製造商' },
];

const PAY_TYPE_OPTIONS = [
  { value: '01', label: '01 現金' },
  { value: '02', label: '02 押匯' },
  { value: '03', label: '03 支票' },
  { value: '04', label: '04 電匯' },
  { value: '05', label: '05 轉帳' },
  { value: '06', label: '06 沖暫借款' },
  { value: '08', label: '08 沖代墊款' },
];

interface Props {
  isEditing: boolean;
  isAddMode: boolean;
  code: string; setCode: (v: string) => void;
  category: string; setCategory: (v: string) => void;
  shortName: string; setShortName: (v: string) => void;
  fullName: string; setFullName: (v: string) => void;
  enName: string; setEnName: (v: string) => void;
  countryCode: string; setCountryCode: (v: string) => void;
  taxId: string; setTaxId: (v: string) => void;
  email: string; setEmail: (v: string) => void;
  website: string; setWebsite: (v: string) => void;
  perfCustomer: boolean; setPerfCustomer: (v: boolean) => void;
  poRequired: boolean; setPoRequired: (v: boolean) => void;
  personInCharge: string; setPersonInCharge: (v: string) => void;
  bankAccount: string; setBankAccount: (v: string) => void;
  oldCodeFlag: boolean; setOldCodeFlag: (v: boolean) => void;
  custCategory: string; setCustCategory: (v: string) => void;
  payType: string; setPayType: (v: string) => void;
  taxRate: number; setTaxRate: (v: number) => void;
}

const Tab1BasicInfo: React.FC<Props> = React.memo(({
  isEditing, isAddMode,
  code, setCode, category, setCategory,
  shortName, setShortName, fullName, setFullName, enName, setEnName,
  countryCode, setCountryCode, taxId, setTaxId,
  email, setEmail, website, setWebsite,
  perfCustomer, setPerfCustomer, poRequired, setPoRequired,
  personInCharge, setPersonInCharge,
  bankAccount, setBankAccount, oldCodeFlag, setOldCodeFlag,
  custCategory, setCustCategory, payType, setPayType, taxRate, setTaxRate,
}) => (
  <div className="space-y-3">
    <div className="flex gap-4">
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">公司代號</label>
        <Input value={code} onChange={e => setCode(e.target.value)} maxLength={12}
          disabled={!isAddMode} style={{ width: 150 }} />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">類別</label>
        <Select value={category} onChange={setCategory} disabled={!isEditing}
          options={CATEGORY_OPTIONS} style={{ width: 140 }} />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">簡稱</label>
        <Input value={shortName} onChange={e => setShortName(e.target.value)} maxLength={10}
          disabled={!isEditing} style={{ width: 120 }} />
      </div>
    </div>
    <div className="flex gap-4">
      <div className="flex-1">
        <label className="block text-xs font-medium text-gray-600 mb-1">全名</label>
        <Input value={fullName} onChange={e => setFullName(e.target.value)} maxLength={150}
          disabled={!isEditing} />
      </div>
    </div>
    <div className="flex gap-4">
      <div className="flex-1">
        <label className="block text-xs font-medium text-gray-600 mb-1">英文全名</label>
        <Input value={enName} onChange={e => setEnName(e.target.value)} maxLength={150}
          disabled={!isEditing} />
      </div>
    </div>
    <div className="flex gap-4">
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">國碼</label>
        <LookupField
          lookupType="countryCode"
          value={countryCode || ''}
          onChange={(code) => setCountryCode(code)}
          disabled={!isEditing}
          title="搜尋國碼"
          style={{ width: 100 }}
        />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">統編/稅編</label>
        <Input value={taxId} onChange={e => setTaxId(e.target.value)} maxLength={15}
          disabled={!isEditing} style={{ width: 160 }} />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">經辦人員</label>
        <LookupField lookupType="employee" value={personInCharge}
          onChange={setPersonInCharge} onCodeConfirm={setPersonInCharge}
          disabled={!isEditing} style={{ width: 120 }} maxLength={8} />
      </div>
    </div>
    <div className="flex gap-4">
      <div className="flex-1">
        <label className="block text-xs font-medium text-gray-600 mb-1">電子郵件</label>
        <Input value={email} onChange={e => setEmail(e.target.value)} maxLength={40} disabled={!isEditing} />
      </div>
      <div className="flex-1">
        <label className="block text-xs font-medium text-gray-600 mb-1">網站</label>
        <Input value={website} onChange={e => setWebsite(e.target.value)} maxLength={40} disabled={!isEditing} />
      </div>
    </div>
    <div className="flex gap-4">
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">票款別</label>
        <Select value={payType} onChange={setPayType} disabled={!isEditing}
          options={PAY_TYPE_OPTIONS} style={{ width: 160 }} />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">發票稅率</label>
        <InputNumber value={taxRate} onChange={v => setTaxRate(v ?? 0.05)}
          min={0} max={1} step={0.01} disabled={!isEditing} style={{ width: 100 }} />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">銀行帳號</label>
        <Input value={bankAccount} onChange={e => setBankAccount(e.target.value)} maxLength={20}
          disabled={!isEditing} style={{ width: 200 }} />
      </div>
    </div>
    <div className="flex gap-4 items-end">
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">客戶類別</label>
        <Radio.Group value={custCategory} onChange={e => setCustCategory(e.target.value)} disabled={!isEditing}>
          <Radio value="A">A 一般</Radio>
          <Radio value="B">B 重點</Radio>
          <Radio value="C">C VIP</Radio>
        </Radio.Group>
      </div>
    </div>
    <div className="flex gap-6 pt-1">
      <Checkbox checked={perfCustomer} onChange={e => setPerfCustomer(e.target.checked)} disabled={!isEditing}>
        業績客戶
      </Checkbox>
      <Checkbox checked={oldCodeFlag} onChange={e => setOldCodeFlag(e.target.checked)} disabled={!isEditing}>
        舊代號
      </Checkbox>
      <Checkbox checked={poRequired} onChange={e => setPoRequired(e.target.checked)} disabled={!isEditing}>
        客戶P/O NO必須輸入
      </Checkbox>
    </div>
  </div>
));

export default Tab1BasicInfo;
